import React, { useCallback, useEffect, useMemo } from 'react';
import './PortfolioDetailHeader.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { isAnyOfThreeBProductTypes } from 'hooks/isThreeBProduct';
import { useTranslation } from 'react-i18next';
import { EXTERNAL_PRODUCTS } from 'constants/constants';

import arrayContains from 'utils/arrayUtils';
import { Select } from 'ui-library';
import {
    BLOCKED,
    NOT_IMPLEMENTED,
} from 'constants/portfolioStatuses';
import { generateDFSClientId } from 'utils';
import useSinglePortfolio from '../../../context/useSinglePortfolio';

export const PortfolioDetailHeader = (props: { portfolioId: number | string }) => {
    const navigate = useNavigate();
    const {
        clientProfile: {
            clientId, portfolios, sectionedPortfolios, setReFetchPortfolios,
        },
    } = useSinglePortfolio() as any;
    const dfsClientId = generateDFSClientId(clientId);
    const { pathname } = useLocation();
    const { i18n: { language } } = useTranslation();

    const allPortfolios = useMemo(
        () => [
            ...(sectionedPortfolios?.jointRegularPortfolios ?? []),
            ...(sectionedPortfolios?.poaPortfolios ?? []),
            ...(sectionedPortfolios?.parentalPortfolios ?? []),
        ],
        [sectionedPortfolios],
    );

    const portfoliosSelectOptions = useMemo(
        () => [...(portfolios ?? []), ...allPortfolios]?.reduce((accu: any[], item: any) => {
            if (
                item.Status?.value !== NOT_IMPLEMENTED
                && item.Status?.value !== BLOCKED
                && !item?.Name?.disabled
                && !accu.some((s) => s.id === item.Id)
                && (pathname?.includes('/cases') ? isAnyOfThreeBProductTypes(item?.ProductExternalId) : true)
                && (pathname?.includes('/deposit') ? arrayContains([EXTERNAL_PRODUCTS.aaa, EXTERNAL_PRODUCTS.aaap], item?.ProductExternalId) : true)
            ) {
                accu.push({
                    id: item?.Id,
                    label: item?.Name?.label,
                    value: item?.Id,
                    product: item?.ProductDesc,
                });
            }

            return accu;
        }, []),
        [portfolios, pathname, allPortfolios],
    );

    const selected = useMemo(() => portfoliosSelectOptions?.find((item: any) => item.id === parseInt(String(props?.portfolioId), 10)), [portfoliosSelectOptions, props?.portfolioId]);

    const onChange = useCallback(
        (item: number | string) => {
            const parsedPathname = pathname.split('/');
            const tabName = parsedPathname[parsedPathname.length - 1];

            navigate(`/client/${dfsClientId}/portfolios/${item}/tab/${tabName}`);
        },
        [pathname, navigate, dfsClientId],
    );

    useEffect(() => {
        setReFetchPortfolios(true);
    }, [language, setReFetchPortfolios]);

    return (
        <div className="PortfolioDetailHeader">
            <div className="PortfolioDetailHeader__Title">
                {!!selected && <h2>{selected?.product}</h2>}
                {!!portfoliosSelectOptions?.length && (
                    <Select
                        value={selected}
                        options={portfoliosSelectOptions}
                        onChange={onChange}
                    />
                )}
            </div>
        </div>
    );
};
